import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient instance for the application.
 * This allows access to the QueryClient both inside and outside React components.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * Helper function to invalidate all count queries at once
 */
export const invalidateAllCountQueries = () => {
  queryClient.invalidateQueries({ queryKey: ['draftsCount'] });
  queryClient.invalidateQueries({ queryKey: ['triageCount'] });
  queryClient.invalidateQueries({ queryKey: ['waitingCount'] });
};
